/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Faq_Page_QInputs */

const en_platform_faq_page_q = /** @type {(inputs: Platform_Faq_Page_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I use my own domain?`)
};

const pl_platform_faq_page_q = /** @type {(inputs: Platform_Faq_Page_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Czy mogę użyć własnej domeny?`)
};

/**
* | output |
* | --- |
* | "Can I use my own domain?" |
*
* @param {Platform_Faq_Page_QInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_faq_page_q = /** @type {((inputs?: Platform_Faq_Page_QInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Faq_Page_QInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_faq_page_q(inputs)
	return en_platform_faq_page_q(inputs)
});